export default __webpack_public_path__ + "static/media/billing-background-card.4fa04d9c.png";